export default __webpack_public_path__ + "static/media/RamFavicon.8c44cfcf.ico";